import React from 'react';
import { Spin, Layout } from 'antd';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const { Content } = Layout;

const PageContent = (props) => {
  return (
    <Spin spinning={props.loading}>
      <Content className={classNames('page-content', props.className)}>{props.children}</Content>
    </Spin>
  );
};

PageContent.propTypes = {
  loading: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
};

PageContent.defaultProps = {
  className: '',
  loading: false,
};

export { PageContent };
